var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('TopSection'),_c('Banner'),_c('Services'),_c('LapSection'),_c('LandingTabs'),_c('PricePlan'),_c('News'),_c('BottomSection'),_c('signup'),_c('Login'),_c('ForgotPasswordLink'),_c('ContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }